import { render, staticRenderFns } from "./VipLevelForm.vue?vue&type=template&id=5642bc66&scoped=true"
import script from "./VipLevelForm.vue?vue&type=script&lang=js"
export * from "./VipLevelForm.vue?vue&type=script&lang=js"
import style0 from "./VipLevelForm.vue?vue&type=style&index=0&id=5642bc66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5642bc66",
  null
  
)

export default component.exports